/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export class GridTypes {
    public static readonly GALLERY: string = 'gallery';

    public static readonly CAST: string = 'castGrid';
}
